import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Meta, Title } from '@angular/platform-browser';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from './util.service';
import { environment } from '../../../environments/environment';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from './cms.service';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private readonly env = environment;

  constructor(
    private readonly cmsS: CmsService,
    private readonly metaS: Meta,
    private readonly titleS: Title,
    private readonly utilS: UtilService,
  ) {}

  setSeoTags(seoData: any): void {
    seoData = this.cmsS.flattenBuilderReferencesPreservingKeys(seoData);
    this.utilS.consoleGroup('SeoData:', seoData);

    if (!this.utilS.isNullOrWhitespace(seoData.title)) {
      this.titleS.setTitle(seoData.title);
    }

    if (this.env.isProduction) {
      if (seoData.robotsNoIndex) {
        this.metaS.addTag({ name: 'robots', content: 'noindex, nofollow' });
      } else {
        this.metaS.removeTag('name="robots"');
      }
    }

    if (!this.utilS.isNullOrWhitespace(seoData.description)) {
      this.metaS.addTag({ name: 'description', content: seoData.description });
    }

    if (!this.utilS.isNullOrWhitespace(seoData.ogTitle)) {
      this.metaS.addTag({ name: 'og:title', content: seoData.ogTitle });
    }

    if (!this.utilS.isNullOrWhitespace(seoData.ogDescription)) {
      this.metaS.addTag({ name: 'og:description', content: seoData.ogDescription });
    }

    if (!this.utilS.isNullOrWhitespace(seoData.ogImage)) {
      this.metaS.addTag({ name: 'og:image', content: seoData.ogImage });
    }

    if (!this.utilS.isNullOrWhitespace(seoData.ogImageAlt)) {
      this.metaS.addTag({ name: 'og:image:alt', content: seoData.ogImageAlt });
    }

    if (!this.utilS.isNullOrWhitespace(seoData.keywords)) {
      this.metaS.addTag({ name: 'keywords', content: seoData.keywords });
    }
  }
}
